import { connect } from 'react-redux';

import { closeModal } from 'actions/modal';
import { MODAL_KICK_ROOM_USER } from 'types/modal';

import { selectors, actions } from '@amplement/backend-connector';
import Component from './index';

const mapStateToProps = (state) => {
    const { _room, _user, isPhoneNumber } = state.modal[MODAL_KICK_ROOM_USER];
    const user = selectors.rooms.getRoomMemberByUserIdSelector(state, _room, _user) || {};

    return ({
        _room,
        _user,
        isPhoneNumber,
        fullname: user?.fullname
    });
}

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(closeModal(MODAL_KICK_ROOM_USER)),
    onKick: (_room, _users) => dispatch(actions.rooms.requestPostRoomKicks(_room, _users))
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
